import { useTheme } from '@mui/material/styles';
import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';

export function Toaster() {
  const theme = useTheme();

  return (
    <SonnerToaster
      position="top-right"
      closeButton
      toastOptions={{
        style: {
          background: theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: `${theme.shape.borderRadius}px`,
          fontFamily: theme.typography.fontFamily,
          fontSize: 14,
        },
      }}
    />
  );
}

export type ToastOptions = { description?: string; duration?: number };

// Wrapped rather than re-exported: sonner's own toast type references an
// internal name this package cannot emit in its declarations, and a narrow
// surface is what call sites actually need.
export const toast = {
  success(message: string, options?: ToastOptions): void {
    sonnerToast.success(message, options);
  },
  error(message: string, options?: ToastOptions): void {
    sonnerToast.error(message, options);
  },
  warning(message: string, options?: ToastOptions): void {
    sonnerToast.warning(message, options);
  },
  info(message: string, options?: ToastOptions): void {
    sonnerToast.info(message, options);
  },
  message(message: string, options?: ToastOptions): void {
    sonnerToast(message, options);
  },
  dismiss(): void {
    sonnerToast.dismiss();
  },
};
